export async function openResolvedExternalUrl(
  resolveUrl: () => Promise<string>,
): Promise<void> {
  const popup = window.open('', '_blank');
  if (!popup) {
    throw new Error('Your browser blocked the new tab. Allow popups for this site and try again.');
  }

  popup.opener = null;
  popup.document.title = 'Opening...';
  popup.document.body.textContent = 'Opening secure record...';

  try {
    const url = await resolveUrl();
    if (!url) {
      throw new Error('No public URL was returned.');
    }
    popup.location.replace(url);
  } catch (error) {
    popup.close();
    throw error;
  }
}
